import * as actionTypes from "./AlertMasterType";

const INITIAL_STATE = {
    alertMasterList: [],
    alerttableList: [],
    alertUserList: [],
};

const AlertMasterReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETALERT:
            return {
                ...state,
                alertMasterList: action.payload.list,
            };
        case actionTypes.SETTABLE:
            return {
                ...state,
                alerttableList: action.payload.list,
            };
        case actionTypes.SETUSERLIST:
            return {
                ...state,
                alertUserList: action.payload.list,
            };
        default:
            return state;
    }
}

export default AlertMasterReducer;